export default function registerCounterSignModal(Alpine) {
  Alpine.data("counterSignModal", () => ({
    open: false,
    method: "typed",
    typedName: "",
    signatureDataUrl: "",
    drawing: false,
    hasInk: false,
    ctx: null,
    init() {
      this.typedName = this.$el.dataset.defaultName || "";
    },
    get canSubmit() {
      if (this.method === "typed") return this.typedName.trim().length > 0;
      return this.hasInk;
    },
    initPad() {
      const c = this.$refs.pad;
      if (!c) return;
      c.width = c.clientWidth * window.devicePixelRatio;
      c.height = c.clientHeight * window.devicePixelRatio;
      this.ctx = c.getContext("2d");
      this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
      this.ctx.lineCap = "round";
      this.ctx.lineWidth = 2;
      this.ctx.strokeStyle = "#0A3D2C";
      const start = (e) => {
        this.drawing = true;
        const p = this.point(c, e);
        this.ctx.beginPath();
        this.ctx.moveTo(p.x, p.y);
      };
      const move = (e) => {
        if (!this.drawing) return;
        const p = this.point(c, e);
        this.ctx.lineTo(p.x, p.y);
        this.ctx.stroke();
        this.hasInk = true;
      };
      const end = () => {
        this.drawing = false;
      };
      c.addEventListener("pointerdown", start);
      c.addEventListener("pointermove", move);
      c.addEventListener("pointerup", end);
      c.addEventListener("pointerleave", end);
    },
    point(c, e) {
      const r = c.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    },
    clearPad() {
      const c = this.$refs.pad;
      if (!c || !this.ctx) return;
      this.ctx.clearRect(0, 0, c.width, c.height);
      this.hasInk = false;
    },
    captureSignature() {
      if (this.method === "drawn" && this.$refs.pad) {
        this.signatureDataUrl = this.$refs.pad.toDataURL("image/png");
      }
    }
  }));
}
